import React from "react"
import usePagination from "@mui/material/usePagination"
import clsx from "clsx"
import Icon from "ui/components/atoms/icon"

import styles from "./Pagination.module.css"

export const Pagination = ({
  defaultPage,
  totalPages,
  onChange,
}: {
  defaultPage?: number
  totalPages: number
  onChange: (e: number) => void
}) => {
  const { items } = usePagination({
    defaultPage: defaultPage,
    count: totalPages,
    onChange: (e, page) => {
      onChange(page)
    },
  })

  return (
    <div className={styles.wrapper}>
      {items.map(({ page, type, selected, ...item }, index) => {
        let children = null

        if (type === "start-ellipsis" || type === "end-ellipsis") {
          children = "…"
        } else if (type === "page") {
          children = (
            <button
              key={index}
              className={clsx(styles.number, {
                [styles.active]: selected,
              })}
              {...item}
            >
              {page}
            </button>
          )
        } else {
          children = (
            <button className={clsx(styles.number, styles.arrow)} {...item}>
              <Icon icon={type === "next" ? "arrow-right" : "arrow-left"} />
            </button>
          )
        }

        return children
      })}
    </div>
  )
}

export default Pagination
